<button
  mat-stroked-button
  color="primary"
  class="full-width"
  [disabled]="!isAbleToSelectService()"
  (click)="openServiceSelectionDialog()"
>
  {{ 'service-selection-form.buttons.add-more' | translate }}
</button>

<lib-spacer></lib-spacer>

@if (selectedProducts?.length > 0) {
<ng-container *ngFor="let product of selectedProducts">
  <div class="flex-row-space-between">
    <button
      mat-icon-button
      color="warn"
      [disabled]="isDisabled"
      (click)="removeProduct(product.id)"
    >
      <mat-icon>delete</mat-icon>
    </button>

    <div class="full-width">
      <div>{{ product.name }}</div>
      <div *ngIf="product.description?.length" class="description-color">
        {{ product.description }}
      </div>
      <div class="description-color">
        <div>{{ product.duration * 60 | durationFormatter }}</div>
      </div>
    </div>

    <div style="text-align: right; min-width: fit-content">
      <div [class.original-price-label]="isAnyDiscountActivated(product)">
        {{ product.price | roundNumberFormatter }}
        {{ businessObject?.currency }}
      </div>
      <div *ngIf="isAnyDiscountActivated(product)" class="highlight-text">
        {{ getDiscountPrice(product) | roundNumberFormatter }}
        {{ businessObject?.currency }}
      </div>
    </div>
  </div>

  <lib-spacer></lib-spacer>
  <lib-divider></lib-divider>
  <lib-spacer></lib-spacer>
</ng-container>
} @else if (!enableCustomDuration) {
<lib-info-box>
  <span>{{ 'service-selection-form.text.hint' | translate }}</span>
</lib-info-box>
<lib-spacer></lib-spacer>
}

<div class="text-align-right">
  {{ 'service-selection-form.text.total' | translate }}:
  <strong
    >{{ totalPrice | roundNumberFormatter }}
    {{ businessObject?.currency }}</strong
  >
</div>

<div class="text-align-right">
  {{ 'service-selection-form.text.duration' | translate }}:
  {{
    (durationControl.value || estimatedDuration || 0) * 60 | durationFormatter
  }}
</div>

<div *ngIf="enableCustomDuration" class="duration-buttons-container">
  <button
    mat-stroked-button
    color="primary"
    size="small"
    [disabled]="!isAbleToChangeDurationByOffset(-DURATION_OFFSET)"
    (click)="changeDurationByOffset(-DURATION_OFFSET)"
  >
    -{{ DURATION_OFFSET * 60 | durationFormatter }}
  </button>
  <button
    mat-stroked-button
    color="primary"
    size="small"
    [disabled]="!isAbleToChangeDurationByOffset(DURATION_OFFSET)"
    (click)="changeDurationByOffset(DURATION_OFFSET)"
  >
    +{{ DURATION_OFFSET * 60 | durationFormatter }}
  </button>
</div>
